import {
  initPage,
  companyListData,
  addCompany,
  editCompany,
  deleteCompany
} from './../api';
const company = {
  namespaced: true,
  state: {
    total:0,
    initResp: null,
    pageResp:null,
    addCompanyResp:null,
    editCompanyResp:null,
    deleteCompanyResp: null
  },
  mutations: {
    INIT_PAGE(state,data){
      state.initResp = data.obj;
    },
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj;
    },
    ADD_COMPANY(state,data){
      state.addCompanyResp = data;
    },
    EDIT_COMPANY(state,data){
      state.editCompanyResp = data;
    },
    DELETE_COMPANY(state,data){
      state.deleteCompanyResp = data;
    },
},
  actions: {
    //初始化
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await companyListData(obj);
      commit('PAGE_INFO', resp);
    },
    //新增事件
    async addCompany({commit}, obj){
      let resp = await addCompany(obj);
      commit('ADD_COMPANY', resp);
    },
    //编辑事件
    async editCompany({commit}, obj){
      let resp = await editCompany(obj);
      commit('EDIT_COMPANY', resp);
    },
    //删除事件
    async deleteCompany({commit}, obj){
      let resp = await deleteCompany(obj);
      commit('DELETE_COMPANY', resp);
    },
  }
}
export default company



// WEBPACK FOOTER //
// ./src/page/mdm/company/store/company.store.js